import { TimeFormat as AntdTimeFormat } from "@empglabs/backoffice-ui-kit"

const TimeFormat = props => {
  return <AntdTimeFormat {...props} />
}

export default TimeFormat
